<div class="rs-control-with-mask">
  <mat-form-field appearance="outline">
    <mat-label>{{placeholder | translate}}*</mat-label>
    <input (focus)="onFocus()" [formControl]="rsFormControl" matInput [mask]="mask" [showMaskTyped]="isMaskVisible">
    <ng-content></ng-content>
  </mat-form-field>
</div>
